"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskTree = void 0;
var mobx_react_1 = require("mobx-react");
var React = require("react");
var riskTreeElement_1 = require("./riskTreeElement");
var config_1 = require("../../config");
var RiskTree = (function (_super) {
    __extends(RiskTree, _super);
    function RiskTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._cache_controls_to_display = {};
        _this._cache_control_has_no_children_result = {};
        _this._cache_risk_has_no_children_result = {};
        _this.riskHasNoActiveChildren = function (risk_element) {
            if (!_this.props.filterElements) {
                return false;
            }
            var risk = risk_element.risk;
            var result = true;
            if (risk.id in _this._cache_risk_has_no_children_result) {
                result = _this._cache_risk_has_no_children_result[risk.id];
            }
            else {
                result = risk_element.controls.reduce(function (sum, control_element) {
                    var control = control_element.control;
                    var result = true;
                    if (control.id in _this._cache_controls_to_display) {
                        result = _this._cache_controls_to_display[control.id];
                    }
                    else {
                        var isFiltered = _this.props.isControlFilteredOut && _this.props.isControlFilteredOut(control_element);
                        var isDisabled = !control.is_assigned_to;
                        result = ((isDisabled || isFiltered) && _this.controlHasNoActiveChildren(control_element));
                        _this._cache_controls_to_display[control.id] = result;
                    }
                    return sum && result;
                }, true);
                _this._cache_risk_has_no_children_result[risk.id] = result;
            }
            return result;
        };
        _this.controlHasNoActiveChildren = function (control_element) {
            if (!_this.props.filterElements) {
                return false;
            }
            var control = control_element.control;
            var result = true;
            if (control.id in _this._cache_control_has_no_children_result) {
                result = _this._cache_control_has_no_children_result[control.id];
            }
            else {
                result = control_element.actions.reduce(function (sum, action_element) {
                    return sum && _this.props.isActionFilteredOut && _this.props.isActionFilteredOut(action_element);
                }, true);
                _this._cache_control_has_no_children_result[control.id] = result;
            }
            return result;
        };
        return _this;
    }
    RiskTree.prototype.render = function () {
        var _this = this;
        this._cache_controls_to_display = {};
        this._cache_risk_has_no_children_result = {};
        this._cache_control_has_no_children_result = {};
        var filtered_ownerships = this.props.ownerships.filter(function (risk_element) {
            if (!_this.props.filterElements) {
                return true;
            }
            var risk = risk_element.risk;
            var isNotFiltered = !(_this.props.isRiskFilteredOut && _this.props.isRiskFilteredOut(risk_element));
            return ((isNotFiltered && risk.is_owned) ||
                !_this.riskHasNoActiveChildren(risk_element));
        });
        var grouped_ownerships = (0, config_1.groupBy)(filtered_ownerships, function (risk_element) { return risk_element.risk.project_title; });
        return (React.createElement(React.Fragment, null, grouped_ownerships.length > 0 ? (React.createElement("div", { className: "table-responsive" },
            React.createElement("table", { className: "table" },
                this.props.topMenu &&
                    React.createElement("thead", null,
                        React.createElement("tr", { className: "RiskTreeHeader--NoBorder" },
                            React.createElement("th", { scope: "col" },
                                React.createElement("input", { type: "checkbox", id: this.props.topMenu.risks.id, onChange: this.props.inputChangeHandler, checked: this.props.topMenu.risks.checked })),
                            React.createElement("th", { scope: "col" },
                                React.createElement("input", { type: "checkbox", id: this.props.topMenu.controls.id, onChange: this.props.inputChangeHandler, checked: this.props.topMenu.controls.checked })),
                            React.createElement("th", { scope: "col" },
                                React.createElement("input", { type: "checkbox", id: this.props.topMenu.actions.id, onChange: this.props.inputChangeHandler, checked: this.props.topMenu.actions.checked })),
                            React.createElement("td", { className: "td--nowrap" },
                                React.createElement("label", { className: "m-0" },
                                    React.createElement("input", { type: "checkbox", id: this.props.topMenu.all.id, style: { display: 'none' }, onChange: this.props.inputChangeHandler }),
                                    gettext("Select all"))),
                            React.createElement("th", { colSpan: 5 }, this.props.headerText))),
                React.createElement("tbody", null, grouped_ownerships.map(function (group) { return (React.createElement(React.Fragment, null,
                    group.key && (React.createElement("tr", null,
                        React.createElement("th", { colSpan: 8 },
                            React.createElement("h3", { className: "my-3" }, group.key)))),
                    group.members.map(function (risk_element) {
                        var risk = risk_element.risk;
                        var key = "".concat(_this.props.key, "_").concat(risk.id);
                        var isFiltered = _this.props.isRiskFilteredOut && _this.props.isRiskFilteredOut(risk_element);
                        var allChildrenAreFiltered = _this.riskHasNoActiveChildren(risk_element);
                        return React.createElement(riskTreeElement_1.RiskTreeElement, { key: key, risk: risk_element, parent_id: key, showCheckbox: _this.props.showCheckboxes, filterElements: _this.props.filterElements, isChecked: _this.props.isChecked, isControlFilteredOut: _this.props.isControlFilteredOut, isActionFilteredOut: _this.props.isActionFilteredOut, controlHasNoActiveChildren: _this.controlHasNoActiveChildren, overWritingFilter: _this.props.filterElements && isFiltered && !allChildrenAreFiltered, inputChangeHandler: _this.props.inputChangeHandler, addNodeIcon: _this.props.addNodeIcon, onClick: _this.props.onClickRisk, onClickControl: _this.props.onClickControl, onClickAction: _this.props.onClickAction, onAddControlClicked: _this.props.onAddControlClicked, onAddActionClicked: _this.props.onAddActionClicked });
                    }))); }))))) : (React.createElement("div", { className: "alert alert-primary", role: "alert" }, gettext("No results matching current project and/or filters.")))));
    };
    RiskTree = __decorate([
        mobx_react_1.observer
    ], RiskTree);
    return RiskTree;
}(React.Component));
exports.RiskTree = RiskTree;
